import { type TransformerConfig } from '../common/types';
import {
  createAbsentAsTransformer,
  createDecodeFromDbFn,
  createEncodeToDbFn,
  createRenameTransformer,
} from '../common/utils';
import { buildRecordId } from '../recordIds';
import { DBLegacyExamMarkingRequestSchema, LegacyExamMarkingRequestSchema } from './schemas';

export const LegacyExamMarkingRequestCodecConfig: TransformerConfig<
  typeof LegacyExamMarkingRequestSchema,
  typeof DBLegacyExamMarkingRequestSchema,
  'examId'
> = {
  name: 'LegacyExamMarkingRequest',
  clientSchema: LegacyExamMarkingRequestSchema,
  dbSchema: DBLegacyExamMarkingRequestSchema,
  transformers: [
    createRenameTransformer<
      typeof LegacyExamMarkingRequestSchema,
      typeof DBLegacyExamMarkingRequestSchema
    >('id', 'requestId'),
    createRenameTransformer<
      typeof LegacyExamMarkingRequestSchema,
      typeof DBLegacyExamMarkingRequestSchema
    >('markerId', 'marker'),
    // A request whose exam was cleared stores '' for its exam's code, subject and label
    createRenameTransformer<
      typeof LegacyExamMarkingRequestSchema,
      typeof DBLegacyExamMarkingRequestSchema
    >('examCode', 'examId', { absentAs: '' }),
    createAbsentAsTransformer<
      typeof LegacyExamMarkingRequestSchema,
      typeof DBLegacyExamMarkingRequestSchema
    >('examSubject', ''),
    createAbsentAsTransformer<
      typeof LegacyExamMarkingRequestSchema,
      typeof DBLegacyExamMarkingRequestSchema
    >('examLabel', ''),
    createRenameTransformer<
      typeof LegacyExamMarkingRequestSchema,
      typeof DBLegacyExamMarkingRequestSchema
    >('studentId', 'student', { absentAs: '' }),
    createAbsentAsTransformer<
      typeof LegacyExamMarkingRequestSchema,
      typeof DBLegacyExamMarkingRequestSchema
    >('studentName', ''),
  ],
  derived: {
    examId: request =>
      request.examSubject && request.examCode
        ? buildRecordId('legacyExam', { subject: request.examSubject, code: request.examCode })
        : undefined,
  },
};

export const encodeLegacyExamMarkingRequestToDb = createEncodeToDbFn(
  LegacyExamMarkingRequestCodecConfig
);
export const decodeLegacyExamMarkingRequestFromDb = createDecodeFromDbFn(
  LegacyExamMarkingRequestCodecConfig
);
